import React, { Fragment } from "react";
import moment from "moment";
import Draggable from "react-draggable";
import clsx from "clsx";

import { selectFormat, MetricTable, truncate } from "./Utils.js";

import XrayInsightsSlider from "./../xray/XrayInsightsSlider";
import XrayAnalysisSlider from "./../xray/XrayAnalysisSlider";
// import XrayTopListSlider from "./../xray/XrayTopListSlider";

import Logo from "./../../i/axe.svg";
import missing_image from "./../../i/missing_image.svg";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";

const metricBar = (cell) => (
  <MetricTable {...cell} graph={cell.trends} graphType="bar" />
);

const metricTableBarChart = (cell) => (
  <MetricTable {...cell} graph={cell.chart} graphType="bar" />
);

export const XRayTooltip = (props) => {
  const {
    data,
    insights,
    distinctTotals,
    formatType,
    showSummary = true,
  } = props;

  const extra = data.extra ? data.extra : null;
  const analysis = data.analysis;

  const getImageSrc = (url) => (url ? url.replace(/'/g, "%27") : missing_image);

  if (extra !== null) {
    const total = extra
      // we ignore the distinct totals from the summary
      .filter(
        (metric) =>
          !distinctTotals
            ?.map((k) => k.toLowerCase())
            ?.includes(metric.key.toLowerCase())
      )
      .reduce((acc, cur) => {
        let val = 0;
        if (cur.value?.total) {
          val = cur.value.total;
        } else if (cur.value) {
          val = cur.value;
        }

        return acc + val;
      }, 0);

    const hasInsights =
      (insights &&
        insights.find(
          (d) => d.date === data.date.date || d.date === data.date
        )) ||
      false;

    const restInsights =
      hasInsights !== undefined && hasInsights.data ? hasInsights.data : false;

    let IMAGE_TOP_CONTENT = {
      backgroundImage: `url(${missing_image})`,
    };

    const topList =
      data.topLists &&
      data.topLists.find(
        (d) =>
          d.date.split("-").slice(1).join("/") === data.date ||
          moment(d.date).format("MM/YYYY") === data.date
      ).topList;

    if (topList) {
      if (topList.thumbnail)
        IMAGE_TOP_CONTENT = {
          backgroundImage: `url(${getImageSrc(topList.thumbnail)})`,
        };

      topList.value = topList.total;
    }

    const topContent = data.topContent && data.topContent.length > 0;

    if (topContent) {
      if (topContent.thumbnail)
        IMAGE_TOP_CONTENT = {
          backgroundImage: `url(${getImageSrc(topContent.thumbnail)})`,
        };

      topContent.value = topContent.views;
      topContent.trends.forEach((chartData) => {
        chartData.value = chartData.views;
        chartData.label = chartData.date;
        // eslint-disable-next-line no-self-assign
        chartData.selected = chartData.selected;
      });
    }

    const period = data.date;
    let datePeriod;
    if (period) {
      const date_period = isNaN(period[0])
        ? `${period.startDate} - ${period.endDate}`
        : data.date.date || data.date;
      datePeriod = date_period;
    }

    let keyStatDate;

    if (data?.payload?.date?.date) {
      keyStatDate = data.payload.date.date;
    } else if (data?.extra?.[0]?.date) {
      keyStatDate = data.extra[0].date;
    } else {
      keyStatDate = data?.date;
    }

    // Articles/Videos
    const contentType = data.articles || data.videos;

    const contentTypeName = data.articles ? "articles" : "videos";

    return (
      <Draggable
        handle=".xray-tooltip__drag"
        defaultPosition={{ x: 0, y: 0 }}
        position={null}
        grid={[5, 5]}
        scale={1}
      >
        <div className="xray-tooltip">
          <header className="xray-tooltip__header xray-tooltip__drag">
            <img className="xray-tooltip__logo" src={Logo} alt="Pickaxe" />
            {keyStatDate ? (
              <span className="xray-tooltip__value-header">{keyStatDate}</span>
            ) : (
              <>
                <span className="xray-tooltip__key-header">X Ray:</span>
                <span className="xray-tooltip__value-header">
                  {datePeriod ? datePeriod : data.date}
                </span>
              </>
            )}
            <span
              className="xray-tooltip__close-icon-barchart"
              onClick={() => props.close()}
            ></span>
          </header>

          <main className="standard-tooltip__main">
            {extra
              .filter(
                (d) =>
                  d.key !== "insights" &&
                  (d.value !== 0 || d.value.total !== 0) &&
                  !distinctTotals?.includes(d.key)
              )
              .map((d, index) => (
                <div className="standard-tooltip__item" key={d.key}>
                  <span
                    className="standard-tooltip__icon"
                    style={{
                      background: d.color,
                    }}
                  ></span>
                  <span
                    className={clsx("standard-tooltip__key", "text-capitalize")}
                    // style={{ color: d.color }}
                  >
                    {d.key}{" "}
                  </span>
                  <span className="standard-tooltip__value">
                    {d.keyStatsValue
                      ? selectFormat("minsec", d.value)
                      : selectFormat(
                          formatType?.type || "number",
                          d.value?.total || d.value,
                          formatType?.mask
                        )}
                  </span>
                </div>
              ))}

            {!keyStatDate ||
              (distinctTotals?.length > 0 && showSummary === false ? null : (
                <>
                  <div className="standard-tooltip__dilimiter1"></div>

                  <div className="standard-tooltip__item">
                    <span
                      className={clsx(
                        "standard-tooltip__key",
                        "text-capitalize",
                        "total"
                      )}
                    >
                      Total{" "}
                    </span>
                    <span className="standard-tooltip__value">
                      {selectFormat(
                        formatType?.type || "number",
                        total,
                        formatType?.mask
                      )}
                    </span>
                  </div>
                </>
              ))}
            {distinctTotals?.map((bar) => {
              const barValue = extra.find((v) => v.key === bar);
              if (!barValue) return null;
              return (
                <Fragment key={bar}>
                  <div className="standard-tooltip__dilimiter1"></div>
                  <div className="standard-tooltip__item">
                    <span
                      className="standard-tooltip__icon"
                      style={{
                        background: "#868E96",
                      }}
                    ></span>
                    <span
                      className={clsx(
                        "standard-tooltip__key",
                        "text-capitalize"
                      )}
                      style={{
                        color: "#868E96",
                      }}
                    >
                      {barValue.key}{" "}
                    </span>

                    <span className="standard-tooltip__value">
                      {selectFormat("number", barValue.value)}
                    </span>
                  </div>
                </Fragment>
              );
            })}

            {contentType && (
              <>
                <div className="mt-3 standard-tooltip__dilimiter2"></div>
                <div className="my-2 standard-tooltip__section-header">
                  The most popular {contentTypeName} on this day.
                </div>
                {contentType.map((content, index) => {
                  if (!content) return null;

                  let IMAGE = {
                    backgroundImage: `url(${missing_image})`,
                  };
                  if (content.metadata_thumb_url) {
                    IMAGE = {
                      backgroundImage: `url(${content.metadata_thumb_url})`,
                    };
                  } else {
                    IMAGE = {
                      backgroundImage: `url(${missing_image})`,
                    };
                  }

                  return (
                    <div
                      className="standard-tooltip__details--posts"
                      key={"content_" + index}
                    >
                      <article className="content-table">
                        <figure className="content-table__figure">
                          <div
                            className="content-table__img"
                            style={IMAGE}
                          ></div>
                        </figure>

                        <section className="content-table__detail">
                          <span className="standard-tooltip__value">
                            {metricTableBarChart(content)}
                          </span>
                        </section>
                      </article>

                      <div className="standard-tooltip__text">
                        {content.title}
                      </div>
                      {contentType.length - 1 > index ? (
                        <div className="standard-tooltip__dilimiter2"></div>
                      ) : null}
                    </div>
                  );
                })}
              </>
            )}

            {restInsights && restInsights.length > 0 && (
              <>
                <div className="mt-3 standard-tooltip__dilimiter2"></div>
                <XrayInsightsSlider data={restInsights} />
              </>
            )}

            {topList && (
              <>
                <div className="mt-3 standard-tooltip__dilimiter2" />
                {/* 
                <XrayTopListSlider data={topList} /> 
                */}
                <div className="mt-3 mb-3 standard-tooltip__section-header">
                  Top 5
                </div>
                {topList.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className="mb-2 standard-tooltip__details--posts"
                    >
                      <article className="content-table">
                        <figure className="content-table__figure">
                          <div
                            className="content-table__img"
                            style={{
                              backgroundImage: `url(${getImageSrc(
                                item.thumbnail
                              )})`,
                            }}
                          />
                        </figure>

                        <section className="content-table__detail">
                          <span className="standard-tooltip__value">
                            {metricBar(item)}
                          </span>
                        </section>
                      </article>

                      <div className="standard-tooltip__text">
                        {truncate(item.title, 200)}
                      </div>
                    </div>
                  );
                })}
              </>
            )}

            {topContent && (
              <>
                <div className="mt-3 standard-tooltip__dilimiter2" />
                <div className="my-2 standard-tooltip__section-header">
                  Top content on this day.
                </div>
                <div className="standard-tooltip__details--posts">
                  <article className="content-table">
                    <figure className="content-table__figure">
                      <div
                        className="content-table__img"
                        style={IMAGE_TOP_CONTENT}
                      />
                    </figure>

                    <section className="content-table__detail">
                      <span className="standard-tooltip__value">
                        {metricBar(topContent)}
                      </span>
                    </section>
                  </article>

                  <div className="standard-tooltip__text">
                    {truncate(topContent.title, 200)}
                  </div>
                </div>
              </>
            )}

            {analysis && (
              <>
                <div className="mt-3 standard-tooltip__dilimiter2"></div>
                <XrayAnalysisSlider extra={extra} />
              </>
            )}
          </main>
        </div>
      </Draggable>
    );
  } else {
    return null;
  }
};

export const XRayTooltipHeader = (props) => (
  <header className="xray-tooltip__header xray-tooltip__drag">
    <img className="xray-tooltip__logo" src={Logo} alt="Pickaxe" />

    <span className="xray-tooltip__key-header">X Ray:</span>
    <span className="xray-tooltip__value-header">{props.date}</span>

    <span
      className="xray-tooltip__close-icon"
      onClick={() => props.close()}
    ></span>
  </header>
);

export const trackXrayCarousel = (
  event,
  type,
  position,
  element_number,
  module_name
) =>
  window.analytics.track(event, {
    module_type: type,
    module_position: position,
    module_element_number: element_number,
    module_name: module_name,
  });

export const XrayCarouselNav = (props) => (
  <nav className="mt-2 slick-nav d-flex justify-content-between">
    <button className="slick-nav__btn" onClick={() => props.prev()}>
      <AiFillCaretLeft size="1.5rem" />
    </button>
    {props.data.length > 1 && (
      <div className="slick-nav__counter">
        {props.slide} of {props.data.length}
      </div>
    )}
    <button className="slick-nav__btn" onClick={() => props.next()}>
      <AiFillCaretRight size="1.5rem" />
    </button>
  </nav>
);
